export const mainTitle = "Sementeira no Camiño"
export const mainSubtitle = "9 - 13 de xuño do 2021"
export const mainUrl = "https://sementeiranocamino.com/"
export const mainDescription =
  "Poesía e cinema ao longo de vilas emblemáticas do Camiño Portugués."
